import React from 'react';
import {Route} from 'react-router';
import dsaView from '../containers/dsaView';

import AdoptionOverviewPPTX from '../containers/analytics/pptx/AdoptionOverviewPPTX';
import RecommendationOnePPTX from '../containers/analytics/pptx/RecommendationsOne';
import RecommendationTwoPPTX from '../containers/analytics/pptx/RecommendationsTwo';
import RollUpOverviewPPTX from '../containers/analytics/pptx/RollUpOverviewPPTX';
import RollUpOverviewPPTXTwo from '../containers/analytics/pptx/RollUpOverviewPPTXTwo';


const routes = [
  {
    path: 'adoption-overview',
    component: AdoptionOverviewPPTX
  },
  {
    path: 'recommendation-one',
    component: dsaView(RecommendationOnePPTX)
  },
  {
    path: 'recommendation-two',
    component: dsaView(RecommendationTwoPPTX)
  },
  {
    path: 'roll-up-overview',
    component: RollUpOverviewPPTX
  },
  {
    path: 'roll-up-overview-2',
    component: RollUpOverviewPPTXTwo
  }
];

const createRoutedComponent = (route) => {
  // eslint-disable-next-line
  return props => {
    return React.createElement(
      route.component,
      props
    );
  };
};

const renderAnalyticsPPTXPreviewRoutes = (basePath) => {
  return routes.map((route, index) => {
    const RoutedComponent = createRoutedComponent(route, index);
    return (
      <Route
        key={index}
        path={`${basePath}/${route.path}`}
        component={RoutedComponent} />
    );
  });
};

export default renderAnalyticsPPTXPreviewRoutes;



// WEBPACK FOOTER //
// ./src/routing/renderAnalyticsPPTXPreviewRoutes.js